module.exports = __webpack_public_path__ + "static/media/woo1.902e626b.png";